import { TriggerTypeApi } from '@voladeum/client';
import { v4 as uuidv4 } from 'uuid';

import { TriggerType } from './types';

export const normalizeTriggerTypes = (data: TriggerTypeApi[]): TriggerType[] =>
  data.map((d) => normalizeTriggerType(d));

export const normalizeTriggerType = (row: TriggerTypeApi): TriggerType => {
  return { ...row, uuid: uuidv4() };
};
